export const GET_USER_MANUAL_LIST = "GET_USER_MANUAL_LIST"
export const GET_USER_MANUAL_LIST_SUCCESS = "GET_USER_MANUAL_LIST_SUCCESS"
export const GET_USER_MANUAL_LIST_ERROR = "GET_USER_MANUAL_LIST_ERROR"

export const GET_USER_MANUAL = "GET_USER_MANUAL"
export const GET_USER_MANUAL_SUCCESS = "GET_USER_MANUAL_SUCCESS"
export const GET_USER_MANUAL_ERROR = "GET_USER_MANUAL_ERROR"
